import { useState, useEffect, useRef } from 'react';
import './App.css';

const FACEBOOK_URL = 'https://www.facebook.com/tudoovo';

const images = [
  '/cakes/image_1.jpg',
  '/cakes/image_2.jpg',
  '/cakes/image_3.jpg',
  '/cakes/image_4.jpg',
  '/cakes/image_5.jpg',
  '/cakes/image_6.jpg',
  '/cakes/image_7.jpg',
  '/cakes/image_8.jpg',
  '/cakes/image_9.jpg',
];

function App() {
  const [selectedIndex, setSelectedIndex] = useState(null);
  const touchStartX = useRef(null);

  const close = () => setSelectedIndex(null);
  const prev = (e) => { e.stopPropagation(); setSelectedIndex((i) => (i - 1 + images.length) % images.length); };
  const next = (e) => { e.stopPropagation(); setSelectedIndex((i) => (i + 1) % images.length); };

  useEffect(() => {
    if (selectedIndex === null) return;
    const onKey = (e) => {
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') setSelectedIndex((i) => (i - 1 + images.length) % images.length);
      if (e.key === 'ArrowRight') setSelectedIndex((i) => (i + 1) % images.length);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [selectedIndex]);

  const onTouchStart = (e) => { touchStartX.current = e.touches[0].clientX; };
  const onTouchEnd = (e) => {
    if (touchStartX.current === null) return;
    const diff = touchStartX.current - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) {
      diff > 0
        ? setSelectedIndex((i) => (i + 1) % images.length)
        : setSelectedIndex((i) => (i - 1 + images.length) % images.length);
    }
    touchStartX.current = null;
  };

  return (
    <div className="page">

      <header className="hero">
        <img
          src="/sem_fundo.png"
          alt="Tud'ovo logo"
          className="hero-logo"
        />
        <p className="hero-tagline">
          Doçaria conventual &amp; pastelaria gourmet, feita com amor
        </p>
        <a
          className="cta-button"
          href={FACEBOOK_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fa fa-facebook" aria-hidden="true"></i>
          &nbsp; Faça já a sua encomenda
        </a>
      </header>

      <div className="divider" aria-hidden="true">
        <span className="divider-ornament">&#10022;</span>
      </div>

      <main className="gallery-section">
        <div className="image-grid">
          {images.map((src, index) => (
            <div key={index} className="image-card" onClick={() => setSelectedIndex(index)}>
              <img
                src={src}
                alt={`Bolo artesanal ${index + 1}`}
                className="image-card__img"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </main>

      <footer className="page-footer">
        <p>
          &copy; {new Date().getFullYear()} Tud&apos;ovo &mdash; Todos os direitos reservados
        </p>
      </footer>

      {selectedIndex !== null && (
        <div
          className="lightbox-overlay"
          onClick={close}
          onTouchStart={onTouchStart}
          onTouchEnd={onTouchEnd}
        >
          <button className="lightbox-close" onClick={close} aria-label="Fechar">&#x2715;</button>
          <button className="lightbox-nav lightbox-nav--prev" onClick={prev} aria-label="Anterior">
            <i className="fa fa-chevron-left" aria-hidden="true"></i>
          </button>
          <img
            src={images[selectedIndex]}
            alt={`Bolo artesanal ${selectedIndex + 1}`}
            className="lightbox-img"
            onClick={(e) => e.stopPropagation()}
          />
          <button className="lightbox-nav lightbox-nav--next" onClick={next} aria-label="Seguinte">
            <i className="fa fa-chevron-right" aria-hidden="true"></i>
          </button>
        </div>
      )}

    </div>
  );
}

export default App;
